import { render, staticRenderFns } from "./AvatarSelect.vue?vue&type=template&id=5075df83&scoped=true&"
import script from "./AvatarSelect.vue?vue&type=script&lang=js&"
export * from "./AvatarSelect.vue?vue&type=script&lang=js&"
import style0 from "./AvatarSelect.vue?vue&type=style&index=0&id=5075df83&prod&lang=css&"
import style1 from "./AvatarSelect.vue?vue&type=style&index=1&id=5075df83&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5075df83",
  null
  
)

export default component.exports